import React, { memo } from 'react';
import Table from '../../../../components/table/Table';
import columns from './columns';
import { COUPON_SELECTED_USER_LIST_TABLE_EMPTY_TEXT } from '../../../../constants/service/app/couponConstants';
import './CouponGenerateSelectedUserList.scss';

const CouponGenerateSelectedUserList = (props) => {
  const { onCheckUser, selectedUserIdList, selectedUserInfoList } = props;

  return (
    <div className="coupon-generate-selected-user-list">
      <div className="control-list">
        <div className="info">선택한 유저 목록 ({selectedUserIdList.length})</div>
      </div>

      <Table
        data={selectedUserInfoList}
        isStriped={true}
        emptyText={COUPON_SELECTED_USER_LIST_TABLE_EMPTY_TEXT}
        isUsedCheckbox={true}
        checkedIdList={selectedUserIdList}
        onCheck={(list) => onCheckUser(list)}
        columns={(utils) =>
          columns({
            ...utils,
          })
        }
      />
    </div>
  );
};

export default memo(CouponGenerateSelectedUserList);
